import axios, { AxiosError } from "axios";
import { store } from "store";
import { logOut } from "store/auth";

axios.interceptors.request.use((request) => {
  const { userToken } = store.getState().authState;
  if (userToken) {
    request.headers.Authorization = `Bearer ${userToken}`;
  }

  return request;
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 403) {
      return Promise.reject(new AxiosError("Access forbidden: 403"));
    }
    if (error?.response?.status === 401) {
      return store.dispatch(logOut());
    }
  }
);

const axiosNew = axios.create({
  baseURL: process.env.REACT_APP_API_URL_1
});

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export { axios, axiosNew };
